module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter"
  }), _vm._v(" "), _c('div', {
    staticClass: "blockquote1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I think everyone in the world is friends if you can only get them to see you don't want to be un-friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "right_1"
  }, [_vm._v("EDITH NESBIT"), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2877983d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Fm2.vue
// module id = 60
// module chunks = 0